import React from 'react';

/**
 * Consistent page header for inner routes — aligns typography with the brand shell.
 */
const PageHero = ({ title, subtitle }) => {
  return (
    <section className="relative overflow-hidden bg-navy text-white">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_-20%,rgba(47,164,183,0.35),transparent)]"
        aria-hidden
      />
      <div className="container-custom relative py-12 md:py-16 lg:py-20 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white drop-shadow-sm max-w-4xl mx-auto mb-4">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        ) : null}
        <div
          className="mt-8 h-px w-16 bg-teal/90 mx-auto rounded-full"
          aria-hidden
        />
      </div>
    </section>
  );
};

export default PageHero;
